import script from "./LitigationMembersList.vue?vue&type=script&setup=true&lang=ts"
export * from "./LitigationMembersList.vue?vue&type=script&setup=true&lang=ts"

import "./LitigationMembersList.vue?vue&type=style&index=0&id=34fcfc23&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34fcfc23"]])

export default __exports__